import { service_url } from "@/api/config";
import Http from "../api/http";

export function login(data) {
  return Http._axios({
    url: `${service_url}/api/v1/accounts/login/`,
    method: "post",
    data: data,
  });
}

export function logout() {
  return Http._axios({
    url: `${service_url}/api/v1/accounts/logout/`,
    method: "post",
  });
}

export function getProfile() {
  return Http._axios({
    url: `${service_url}/api/v1/accounts/user/`,
    method: "get",
  });
}

export function registration(data) {
  return Http._axios({
    url: `${service_url}/api/v1/accounts/register/`,
    method: "post",
    data: data,
  });
}
export function registrationTemp(data) {
  return Http._axios({
    url: `${service_url}/api/v1/accounts/register/temp/`,
    method: "post",
    data: data,
  });
}

export function updateTemp(data) {
  return Http._axios({
    url: `${service_url}/api/v1/accounts/register/temp/`,
    method: "patch",
    data: data,
  });
}

export function resetPassword(data) {
  return Http._axios({
    url: `${service_url}/api/v1/accounts/password-reset/`,
    method: "post",
    data: data,
  });
}
export function resetPasswordConfirm(data) {
  return Http._axios({
    url: `${service_url}/api/v1/accounts/password-reset-confirm/`,
    method: "post",
    data: data,
  });
}

export function getSubscribtions(id) {
  return Http._axios({
    url: `${service_url}/api/v1/users/me/subscribtion/${id}/`,
    method: "get",
  });
}

export function updateProfile(data) {
  return Http._axios({
    url: `${service_url}/api/v1/accounts/user/profile/`,
    method: "patch",
    data: data,
  });
}

export function uploadProfileImage(file) {
  const formData = new FormData();
  formData.append("profile_image", file);

  return Http._axios({
    url: `${service_url}/api/v1/accounts/user/profile/`,
    method: "patch",
    data: formData,
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
}
